define('form/jquery.validator',['jquery'], function($) {
	/**
	 * jQuery validatie
	 * Based on HTML5
	 * 
	 * options 
	 * 	msg : [ required, regex, length, range ]
	 * 
	 * 
	 */
	$.fn.validator = function (options) {
		
		var settings = $.extend({
			msg : {
				required : 'Dit veld is verplicht',
				regex : 'Dit veld heeft niet het juiste formaat',
				length : 'Dit veld is te lang',
				range : 'Dit veld ligt niet in de verwachte range'
			}
		}, options);
		
		// private methods
		var method = {
			
			clearError : function (el) {
				p = el.parent('.rule');
				p.find('span.error').empty().remove();
				p.removeClass('hasError');
			},
			
			addError : function (el, msg) {
				method.clearError(el);
				
				p = el.parent('.rule');
				p.addClass('hasError');
				
				var msg_err = method.getErrorMessage(msg);
				p.append(msg_err);
				
				if(msg_err.prev().is('.mceEditor')) {
					msg_err.addClass('ident');
				}
			},
			
			hasError : function (el) {
				return el.parent('.rule').is('.hasError');
			},
			
			// animate clear
			amimateClear : function (el) {
				el.parent('.rule').find('span.error').fadeOut(300, function () {
					method.clearError(el);
				});
			},
			
			// generate msg
			getErrorMessage : function (msg) {
				return $('<span class="error"><span>'+msg+'</span></span>').data('generated', 1).css('display', 'inline-block');
			},
			
			/**
			 * Init all form elements
			 */
			init : function (form) {
				// disable validatie van HTML5 van de browser
				form.attr('novalidate', 'novalidate');
				
				// init events on every input except html input
				$(form).on({
					'input' : function (e) {
						method.validate.call(this, e, $(this).val());
					},
					'blur' : function (e) {
						method.validate.call(this, e, $(this).val());
					}
				}, 'input, select, textarea:not(.html)');
				
			},
			
			// run the validation
			run : function (form) {
				var valid = true;
				form.find('input, select, textarea').each(function () {
					var e = $(this);
					
					// getting the value...
					var value = e.is('.html') ? e.text() : e.val();
					
					// fallback van textarea
					if(value == "" && e.val() != "") { 
						value = e.val();
					} 
					
					method.validate.call(this, null, value);
					
					if(method.hasError(e)) {
						valid = false;
					}
				});
				
				return valid;
			},
			
			// private validator for every type
			validate : function (event, value) {
				if(value == undefined) return;
				
				var el = $(this);

				//Voer geen validatie uit op verborgen elementen
				if (el.parents('.hidden').length>0)
					return true;
				
				var v = value;
				
				var succes = true, _hasError = false;
				
				// test wrapper 
				function test(prevHasError, el, isError, msg) {
					if(isError) {
						succes = false;
						method.addError(el, msg);
					} else if(!prevHasError) {
						method.clearError(el);
					}
					
					return prevHasError || isError;
				}
				// test on pattern
				_hasError = test(_hasError, el, v.length > 0 && el.attr('pattern') != undefined && el.attr('type') != 'file' && null == v.match(new RegExp(el.attr('pattern'), "i")), settings.msg.regex);
				
				// test on length
				_hasError = test(_hasError, el, el.attr('maxlength') != undefined && v.length > parseInt(el.attr('maxlength')), settings.msg.length);
				
				// test on range
				_hasError = test(_hasError, el, el.attr('data-range') != undefined && !$.inArray(v, jQuery.parseJSON(el.attr('data-range'))), settings.msg.range);
				
				// test on required
				_hasError = test(_hasError, el, el.attr('required') != undefined && v.length <= 0, settings.msg.required);	
				
				return succes;
			}
		};
		
		// jquery call
		return this.each(function () {
			
			var form = $(this);
			
			if(form.is('form')) {
				method.init(form);
				
				// false callback als het niet goed is
				form.on("submit", function (event) {
					if(!method.run(form))
						return false;
				});
			}
			
		});
		
	};
});
